export default __webpack_public_path__ + "content/media/10.65bad582.jpg";